{"schemaVersion":1,"release":{"version":"1.1.7","build":169,"url":"https://cdn.gab.ai/macos/updates/installers/Gab-AI-1.1.7-169.dmg","sha256":"30f4ab4d2ca3ce3440a658890392972478a81b2767ad074700090923c047d158","size":29355053}}
